import * as Yup from "yup";

export const SignUpSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("Please enter your first name")
    .matches(/\S/, "Please enter your first name"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Please enter your email address"),
  password: Yup.string()
    .required("Please enter your password")
    .min(8, "Password must be at least 8 characters long")
    .matches(/^(?=.*\d)/, "At least 1 numeric digit is required")
    .matches(/^(?=.*[A-Z])/, "At least 1 uppercase character is required")
    .matches(/^(?=.*[a-z])/, "At least 1 lowercase character is required")
    .matches(/^(?=.*[@$!%*?&])/, "At least 1 special character is required"),
  isAdult: Yup.boolean()
    .required("You have to be 18 years or older to sign up")
    .oneOf([true], "You must be 18 years or older to sign up"),
  isUSResident: Yup.boolean()
    .required("You have to be a resident of the United States to sign up")
    .oneOf([true], "You need to be a resident of the United States to sign up"),
});
